import { alpha, TextField } from "@mui/material";
import { useContext, useState } from "react";

import Context from "../../../context";

// ----------------------------------------------------------------------

type Props = {
	label: string;
	type: string;
};

export const TextInputField = ({ type, label }: Props) => {
	const [value, setValue] = useState("");
	const { values } = useContext(Context);
	const { primaryTextColor, secondaryTextColor, strokeColor, primaryColor } = values;

	return (
		<TextField
			label={label}
			type={type}
			value={value}
			onChange={(e) => setValue(e.target.value)}
			sx={{
				"& label": {
					color: primaryTextColor
				},
				"& .MuiOutlinedInput-root": {
					"& fieldset": {
						borderColor: alpha(strokeColor, 0.3)
					},
					"&:hover fieldset": {
						borderColor: primaryColor
					},
					"&.Mui-focused fieldset": {
						borderColor: primaryColor
					},
					"& input": {
						color: primaryTextColor
					}
				}
			}}
			inputProps={{
				style: {
					color: primaryTextColor
				}
			}}
			InputLabelProps={{
				style: {
					color: alpha(secondaryTextColor, 0.8)
				}
			}}
			FormHelperTextProps={{
				style: {
					color: primaryTextColor
				}
			}}
		/>
	);
};

export default TextInputField;
